import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { TabsState, Tab } from '@models/index'

const initialState: TabsState = {
  tabs: [],
  activeTabId: null,
}

const tabsSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    addTab: (state, action: PayloadAction<Omit<Tab, 'active'>>) => {
      const newTab: Tab = {
        ...action.payload,
        active: true,
      }

      // Deactivate all other tabs
      state.tabs.forEach((tab) => {
        tab.active = false
      })

      state.tabs.push(newTab)
      state.activeTabId = newTab.id
    },
    removeTab: (state, action: PayloadAction<string>) => {
      const index = state.tabs.findIndex((tab) => tab.id === action.payload)

      if (index !== -1) {
        state.tabs.splice(index, 1)

        // If removed tab was active, activate the next tab or previous
        if (state.activeTabId === action.payload) {
          if (state.tabs.length > 0) {
            const newActiveTab = state.tabs[Math.max(0, index - 1)]
            newActiveTab.active = true
            state.activeTabId = newActiveTab.id
          } else {
            state.activeTabId = null
          }
        }
      }
    },
    setActiveTab: (state, action: PayloadAction<string>) => {
      state.tabs.forEach((tab) => {
        tab.active = tab.id === action.payload
      })
      state.activeTabId = action.payload
    },
    updateTabData: (state, action: PayloadAction<{ id: string; data: any }>) => {
      const tab = state.tabs.find((tab) => tab.id === action.payload.id)
      if (tab) {
        tab.data = action.payload.data
      }
    },
    updateTabTitle: (state, action: PayloadAction<{ id: string; title: string }>) => {
      const tab = state.tabs.find((tab) => tab.id === action.payload.id)
      if (tab) {
        tab.title = action.payload.title
      }
    },
  },
})

export const { addTab, removeTab, setActiveTab, updateTabData, updateTabTitle } = tabsSlice.actions
export default tabsSlice.reducer
